import { SelectFormInput } from "components/inputs";
import {
  useContractOrderRequestModesOfTransportation,
  useRequestOrderFormSelectedOptions,
} from "hooks/api/requestOrder";
import useSingleOptionAsFormDefault from "hooks/useSingleOptionAsFormDefault";

const ModeSelect = ({ id }: { id: string }) => {
  const selectedOptions = useRequestOrderFormSelectedOptions();

  const {
    data: modeOptions,
    isInitialLoading,
    isRefetching,
  } = useContractOrderRequestModesOfTransportation(selectedOptions);

  useSingleOptionAsFormDefault(id, modeOptions);

  const isLoading = isInitialLoading || isRefetching;

  return (
    <SelectFormInput
      id={id}
      label="Mode"
      options={modeOptions}
      isLoading={isLoading}
      isDisabled={isLoading || (modeOptions?.length ?? 0) <= 1}
      placeholder="Select mode"
    />
  );
};

export default ModeSelect;
